import * as editorConfigs from "constants-lib/aemComponentEditorConfigs"
import CustomCoreContainer from "./Container/ContainerContainer"

const MAPPED_RESPONSIVE_GRID_ONLY_COMPONENTS = {
  // core that only exist in wm-next due to package differences
  [editorConfigs.CustomCoreContainerMappedPath]: CustomCoreContainer,
}

export default MAPPED_RESPONSIVE_GRID_ONLY_COMPONENTS
